import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#1e34b2",
        secondary: "#e1ad4a",
        accent: "#3FA198",
        error: "#b71c1c",
      },
    },
  },
});
